export default __webpack_public_path__ + "static/media/diploma-sanando-amor.90d75942.jpeg";